<template>
  <div class="contact-data signature-view split-view fill-height">
    <v-row class="split-view__row fill-height" no-gutters>
      <left-side-image />
      <v-col cols="12" md="7" class="split-view__panel">
        <div class="split-view__scroll">
        <nav-bar-page />

        <v-container>
          <v-row justify="center" class="mt-0">
            <v-col cols="12" class="mt-0 py-0">
              <v-stepper alt-labels elevation="0">
                <v-stepper-header>
                  <v-stepper-step step="" class="active-step today-medium">
                    Póliza
                  </v-stepper-step>

                  <v-divider inset class="active-separator-step"></v-divider>

                  <v-stepper-step step="" class="active-step today-medium">
                    Simulador
                  </v-stepper-step>

                  <v-divider class="active-separator-step"></v-divider>

                  <v-stepper-step step="" class="active-step today-medium">
                    Formulario
                  </v-stepper-step>

                  <v-divider class="active-separator-step"></v-divider>

                  <v-stepper-step step="" class="active-step today-medium">
                    Firma de documentos
                  </v-stepper-step>

                  <v-divider class="grey-separator-step"></v-divider>

                  <v-stepper-step step="" class="grey-step today-medium">
                    Pago
                  </v-stepper-step>
                </v-stepper-header>
              </v-stepper>
            </v-col>
            <v-col class="text-center justify-center d-flex d-sm-none">
              <div class="text-h6 today-medium primary--text">
                Firma de documentos
              </div>
            </v-col>
          </v-row>

          <v-row justify="center">
            <v-col cols="12" md="10" class="px-4">
              <section class="signature-doc">
                <h2 class="signature-doc__title today-medium">
                  Revisa los documentos
                </h2>
                <p class="signature-doc__hint today-light">
                  Lee el contenido y, si estás de acuerdo, continúa para firmar
                  con el código que te enviaremos por SMS.
                </p>

                <div class="signature-doc__frame">
                  <template v-if="pdf">
                    <object
                      class="bio-pdf-viewer"
                      :data="pdf + '#view=FitH'"
                      type="application/pdf"
                      aria-label="Documentos para firmar"
                    >
                      <embed :src="pdf + '#view=FitH'" type="application/pdf" />
                    </object>
                  </template>
                  <div v-else class="signature-doc__loading">
                    <v-progress-circular
                      :size="40"
                      color="primary"
                      indeterminate
                      aria-label="Cargando documentos"
                    ></v-progress-circular>
                  </div>
                </div>

                <div
                  v-if="content"
                  class="signature-doc__legal today-regular"
                  v-html="content"
                ></div>

                <v-btn
                  block
                  class="signature-btn signature-btn--primary today-medium"
                  elevation="0"
                  :loading="loading"
                  :disabled="loading || !pdf"
                  @click="openOtpDialog"
                >
                  Continuar
                </v-btn>
              </section>
            </v-col>
          </v-row>
        </v-container>
        </div>
      </v-col>
    </v-row>

    <v-dialog
      v-model="otpDialog"
      max-width="400"
      overlay-color="primary"
      content-class="signature-otp-dialog"
      :persistent="loadingOtp"
    >
      <v-card class="signature-otp-card">
        <v-card-title
          class="justify-center text-uppercase primary--text font-weight-bold today-medium signature-otp-card__title"
        >
          Verificar código
        </v-card-title>
        <div class="px-10 px-md-12 pb-7">
          <p class="signature-otp-card__hint today-light">
            Ingresa el código de verificación que recibiste por SMS.
          </p>

          <v-form ref="form" lazy-validation>
            <v-row>
              <v-col
                v-for="(key, i) in activationKeyFields"
                :key="i"
                cols="2"
                class="px-1 text-center"
              >
                <v-text-field
                  type="text"
                  inputmode="numeric"
                  autocomplete="one-time-code"
                  :spellcheck="false"
                  :data-length="key.length"
                  :data-index="i"
                  :ref="`input-${i}`"
                  v-model="key.value"
                  v-on:keyup="handleActivationInput($event)"
                  class="px-0 code-input"
                  outlined
                  dense
                  color="primary"
                  maxLength="1"
                  :aria-label="'Dígito ' + (i + 1) + ' del código'"
                ></v-text-field>
              </v-col>
            </v-row>

            <p
              v-if="!reSendCode"
              class="signature-otp-card__timer today-medium"
            >
              Se habilitará un nuevo código en 00:{{
                String(countdown).padStart(2, "0")
              }}
            </p>
            <p v-else class="text-center">
              <a
                href="#"
                class="signature-otp-card__resend today-regular"
                @click.prevent="reSendSignatureOtp()"
              >
                Reenviar código
              </a>
            </p>

            <v-btn
              block
              :loading="loadingOtp"
              :disabled="loadingOtp"
              color="primary"
              class="signature-btn signature-btn--primary today-medium mt-4"
              elevation="0"
              @click="goPayment"
            >
              Verificar código
            </v-btn>
          </v-form>
        </div>
      </v-card>
    </v-dialog>

    <v-snackbar
      v-model="snackbar"
      :timeout="4000"
      bottom
      right
      role="status"
    >
      <div v-html="snackbarMessage"></div>
    </v-snackbar>
  </div>
</template>

<script>
import LeftSideImage from "@/components/Layouts/LeftSideImage";
import NavBarPage from "@/components/Layouts/NavBarPage";
import { api } from "@/helpers/axios";
import { constants } from "@/helpers/constants";
import { locals } from "@/helpers/locals";

export default {
  name: "SignatureDocuments",
  components: { LeftSideImage, NavBarPage },
  data() {
    return {
      codeSent: false,
      expires_in: 120,
      countdown: "",
      settings: null,
      request: null,
      activationKeyFields: [
        { length: 1, value: "" },
        { length: 1, value: "" },
        { length: 1, value: "" },
        { length: 1, value: "" },
        { length: 1, value: "" },
        { length: 1, value: "" },
      ],
      snackbar: false,
      snackbarMessage: "",
      content: "",
      pdf: "",
      loading: false,
      reSendCode: false,
      otpDialog: false,
      loadingOtp: false,
    };
  },
  mounted() {
    this.getSignDocuments();
  },
  methods: {
    toastTest(typeEvent) {
      this.snackbarMessage = typeEvent;
      this.snackbar = true;
    },

    openOtpDialog() {
      if (this.loading) {
        return;
      }
      this.loading = true;
      this.sendSignatureOtp()
        .then((otp) => {
          this.otpDialog = true;
          if (otp && otp.message) {
            this.snackbarMessage = otp.message;
            this.snackbar = true;
          }
          this.startCountDown();
        })
        .finally(() => {
          this.loading = false;
        });
    },

    goPayment() {
      this.loadingOtp = true;
      let token = "";
      this.activationKeyFields.forEach((value) => {
        token = token + value.value;
      });

      if (token.length == 6) {
        this.loading = true;
        api
          .post(
            constants.endPoints.signDocument,
            {
              user_request_id: this.request.id,
              token: token,
            },
            true
          )
          .then((response) => {
            this.loadingOtp = false;
            this.loading = false;

            let dataResponse = response.data;
            console.log("signDocument", dataResponse);

            this.snackbarMessage = dataResponse.message;
            this.snackbar = true;

            if (dataResponse.status) {
              this.otpDialog = false;
              this.$router.push("/pago");
            }
          })
          .catch(
            function (error) {
              this.loadingOtp = false;
              this.loading = false;
              console.log("errors: ", error);

              try {
                let status = error.response.status;
                if (status == 401) {
                  //locals.clearLocal();
                  //this.$router.push('/');
                }
                let errors = error.response.data.errors;
                let message = "";
                for (var [key, value] of Object.entries(errors)) {
                  console.log(key + " : " + value);
                  message = message + value + "<br>";
                }
                this.snackbarMessage = message;
                this.snackbar = true;
                this.loadingOtp = false;
              } catch (e) {
                console.log(e);

                this.snackbarMessage = e;
                this.snackbar = true;

                //locals.clearLocal();
                //this.$router.push('/');
              }
            }.bind(this)
          );
      } else {
        this.loadingOtp = false;
        this.snackbarMessage = "El código debe tener 6 dígitos";
        this.snackbar = true;
      }
    },
    startCountDown: function () {
      if (this.interval) {
        clearInterval(this.interval);
      }
      this.reSendCode = false;
      this.countdown = this.expires_in;
      this.interval = setInterval(() => {
        if (this.countdown === 0) {
          clearInterval(this.interval);
          this.countdown = this.expires_in;
          this.reSendCode = true;
        } else {
          this.countdown -= 1;
          this.reSendCode = false;
        }
      }, 1000);
    },
    sendSignatureOtp() {
      return api
        .post(
          constants.endPoints.reSendSignatureOtp,
          {
            user_request_id: this.request.id,
          },
          true
        )
        .then((response) => {
          const payload = response.data || {};
          const dataResponse = payload.data || payload;
          return dataResponse.otp || {};
        })
        .catch(
          function (error) {
            try {
              let status = error.response.status;
              if (status == 401) {
                locals.clearLocal();
                this.$router.push("/");
              }
              let errors = error.response.data.errors;
              let message = "";
              for (var [key, value] of Object.entries(errors)) {
                message = message + value + "<br>";
              }
              this.snackbarMessage = message || "No se pudo enviar el código";
              this.snackbar = true;
            } catch (e) {
              this.snackbarMessage = "No se pudo enviar el código";
              this.snackbar = true;
            }
            return Promise.reject(error);
          }.bind(this)
        );
    },
    reSendSignatureOtp() {
      this.sendSignatureOtp().then((otp) => {
        if (otp && otp.message) {
          this.snackbarMessage = otp.message;
          this.snackbar = true;
        }
        this.startCountDown();
      });
    },
    goNext(event) {
      console.log(this.$refs.digit2);
      this.$refs.digit2.focus();
    },
    handleActivationInput(event) {
      // Grab input's value
      let value = event.target.value;
      // Grab data-index value
      let index = parseInt(event.target.dataset.index);
      // Grab data-length value
      let maxlength = event.target.dataset.length;

      if (this.activationKeyFields[index].value.length > maxlength) {
        event.preventDefault();
        this.activationKeyFields[index].value = value.slice(0, 6);
        try {
          this.$refs[`input-${parseInt(index + 1)}`][0].focus();
        } catch (e) {}
        return;
      }

      // Shift focus to next input field if max length reached
      if (value.length >= maxlength) {
        if (typeof this.activationKeyFields[index + 1] == "undefined") {
          event.preventDefault();
          return;
        }
        this.$refs[`input-${parseInt(index + 1)}`][0].focus();
        event.preventDefault();
      }
      console.log(event, index, maxlength, this.activationKeyFields);
    },

    getSignDocuments() {
      api
        .post(
          constants.endPoints.signDocuments,
          {
            user_request_id: this.request.id,
          },
          true
        )
        .then((response) => {
          let dataResponse = response.data.data;

          this.content = dataResponse.content;
          this.pdf = dataResponse.pdf;
        })
        .catch(
          function (error) {
            //
            console.log("errors: ", error);

            try {
              let status = error.response.status;
              if (status == 401) {
                locals.clearLocal();
                this.$router.push("/");
              }
              let errors = error.response.data.errors;
              let message = "";
              for (var [key, value] of Object.entries(errors)) {
                console.log(key + " : " + value);
                message = message + value + "<br>";
              }
              this.snackbarMessage = message;
              this.snackbar = true;
              this.loading = false;
            } catch (e) {
              this.snackbarMessage = e;
              this.snackbar = true;
              console.log(e);
              //locals.clearLocal();
              this.$router.push("/");
            }
          }.bind(this)
        );
    },
  },
  created: function () {
    this.settings = locals.getLocal("settings");
    this.request = locals.getLocal("request");

    this.settings.config.forEach((value) => {
      if (value.key == "otp_seconds") {
        this.expires_in = value.value;
      }
    });
  },
  computed: {
    activationKey() {
      let value = "";
      for (let field of this.activationKeyFields) {
        value += field.value;
      }
      return value;
    },
  },
  destroyed() {
    clearInterval(this.interval);
  },
};
</script>

<style lang="scss">
.signature-view {
  .signature-doc {
    margin-bottom: 28px;
  }

  .signature-doc__title {
    color: #00205b;
    font-size: 0.95rem;
    font-weight: 600;
    letter-spacing: 0.02em;
    margin: 4px 0 8px;
    text-wrap: balance;
  }

  .signature-doc__hint {
    color: rgba(0, 0, 0, 0.64);
    font-size: 0.875rem;
    line-height: 1.45;
    margin: 0 0 16px;
    text-wrap: pretty;
  }

  .signature-doc__frame {
    background: #f8f9fc;
    border: 1px solid #e6e8ee;
    border-radius: 16px;
    overflow: hidden;
  }

  .signature-doc__frame .bio-pdf-viewer {
    display: block;
    height: 380px;
    width: 100%;
  }

  .signature-doc__loading {
    align-items: center;
    display: flex;
    height: 220px;
    justify-content: center;
  }

  .signature-doc__legal {
    color: #00205b;
    font-size: 0.875rem;
    line-height: 1.5;
    margin: 16px 0 20px;
    overflow-wrap: anywhere;
    text-wrap: pretty;
  }
}

.signature-btn {
  border-radius: 10px !important;
  font-size: 0.9375rem !important;
  height: 44px !important;
  letter-spacing: 0 !important;
  min-height: 44px;
  text-transform: none !important;
  touch-action: manipulation;
  transition-duration: 150ms;
  transition-property: transform, background-color, color, box-shadow, opacity;
  transition-timing-function: ease-out;
}

.signature-btn:active:not(.v-btn--disabled) {
  transform: scale(0.96);
}

.signature-btn--primary {
  background: #00205b !important;
  box-shadow: 0 1px 2px rgba(0, 32, 91, 0.18), 0 6px 16px rgba(0, 32, 91, 0.12);
  color: #ffffff !important;
}

.signature-btn--primary:hover:not(.v-btn--disabled) {
  background: #001846 !important;
}

.signature-btn.v-btn--disabled {
  opacity: 0.5;
}

.signature-btn:focus-visible {
  outline: 2px solid #00205b;
  outline-offset: 3px;
}

.signature-otp-dialog {
  border-radius: 20px !important;
  overflow: hidden;
  overscroll-behavior: contain;
}

.signature-otp-card {
  border-radius: 20px !important;
  overflow: hidden;
}

.signature-otp-card__title {
  padding-top: 32px !important;
  text-wrap: balance;
}

.signature-otp-card__hint {
  color: rgba(0, 0, 0, 0.64);
  font-size: 0.875rem;
  line-height: 1.45;
  margin: 0 0 20px;
  text-align: center;
  text-wrap: pretty;
}

.signature-otp-card__timer {
  color: #00205b;
  font-size: 0.8125rem;
  font-variant-numeric: tabular-nums;
  margin: 4px 0 0;
  text-align: center;
}

.signature-otp-card__resend {
  color: #00205b;
  display: inline-block;
  min-height: 44px;
  padding: 12px 0;
  text-decoration: underline;
  text-underline-offset: 2px;
}

.signature-otp-card .code-input input {
  font-size: 1.125rem !important;
  font-variant-numeric: tabular-nums;
  text-align: center;
}

@media (prefers-reduced-motion: reduce) {
  .signature-btn {
    transition: none;
  }

  .signature-btn:active:not(.v-btn--disabled) {
    transform: none;
  }
}

.v-stepper__label {
  font-size: 13px;
}

.active-step .v-stepper__label {
  color: #00205b !important;
}

.active-step > span {
  min-width: 12px !important;
  height: 12px !important;
  width: 12px !important;
  background: #00205b !important;
}

.grey-step > span {
  min-width: 12px !important;
  height: 12px !important;
  width: 12px !important;
}

.v-stepper--alt-labels .v-stepper__header .v-divider {
  margin-top: 29px !important;
}

.active-separator-step {
  border-color: #00205b !important;
}

.grey-separator-step {
  border-color: rgba(0, 0, 0, 0.38) !important;
}

.v-divider {
  border-width: 1px 2px 2px !important;
}

.v-stepper--alt-labels .v-stepper__header .v-divider {
  margin: 29px -82px 0 !important;
}

@media (max-width: 600px) {
  .signature-view .signature-doc__frame {
    border-radius: 14px;
  }

  .signature-view .signature-doc__frame .bio-pdf-viewer {
    height: 280px;
  }

  .v-stepper--alt-labels .v-stepper__step {
    flex-basis: 120px !important;
    padding: 5px !important;
  }

  .v-divider {
    visibility: hidden;
  }
}
</style>
